import { Permission } from '../../services/graphql/src/lib/users/roles-and-permissions';

export default Permission;
